<template>
  <div class="sellCenter container">
    <!-- 过滤条件start -->
    <div ref="headerBtn" class="headerBtn">
      <!-- 顶部按钮start -->
      <div>
        <el-button @click="toAddstaff" size="mini" type="info"
          >添加员工</el-button
        >
        <el-button size="mini" @click="resetPage" type="info">刷新</el-button>
      </div>
      <!-- 顶部按钮end -->
    </div>
    <!-- 过滤条件end -->
    <div>
      <el-table
        :data="list"
        border
        highlight-current-row
        v-loading="loading"
        size="mini"
        :height="tabHeight"
        @selection-change="handleSelectionChange"
        :style="{ 'background-color': 'transparent' }"
        :header-cell-style="{ 'background-color': '#f8f8f8' }"
      >
        <el-table-column type="expand">
          <template slot-scope="scope">
            <div class="staffDetailBox">
              <div>
                <div class="staffDetailItem">
                  <div class="staffDetailItemText">
                    昨日绩效(万元): {{ scope.row.yesterday||'暂无'}}
                  </div>
                  <div class="staffDetailItemText">  今日绩效(万元): {{ scope.row.today||'暂无'}}</div>
                  <div class="staffDetailItemText">
                     本月绩效(万元): {{ scope.row.currentMonth||'暂无'}}
                  </div>
                  <div class="staffDetailItemText">
                     上月绩效(万元): {{ scope.row.lastMonth||'暂无'}}
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="序号" type="index" width="50">
        </el-table-column>

        <el-table-column
          width="150"
          show-overflow-tooltip
          align="center"
          label="操作"
        >
          <div slot-scope="scope">
            <!-- <el-button class="_mini" type="info" size="mini">设置</el-button> -->
            <!-- <el-button class="_mini" type="info" size="mini"
              >查看库存</el-button
            > -->
            <el-button
              @click="() => editstaff(scope.row)"
              class="_mini"
              type="info"
              size="mini"
              >角色编辑</el-button
            >

            <el-button
              class="_mini"
              @click="() => deletestaff(scope.row)"
              type="danger"
              size="mini"
              >删除</el-button
            >
            <!--
            <el-button class="_mini" type="info" size="mini"
              >设置秒杀</el-button
            > -->
          </div>
        </el-table-column>

        <el-table-column
          show-overflow-tooltip
          align="center"
          prop="name"
          label="昵称"
          width="150"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          width="180"
          prop="stockCount"
          label="角色"
        >
          <template slot-scope="scope">
            <div class="green">
              {{ initRoleName(scope.row.roleName) }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          show-overflow-tooltip
          align="center"
          prop="id_card"
          label="身份证号"
          width="150"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          width="100"
          prop="callWay"
          label="联系电话"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="coverPlan"
          align="center"
          label="用户头像"
          width="100"
        >
          <template slot-scope="scope">
            <el-image
              style="width: 50px; height: 50px"
              :src="getImageUrl(scope.row.headImg)"
              fit="cover"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          prop="status"
          label="是否是店铺联系人"
          width="150"
        >
          <template slot-scope="scope">
            <div :class="setClass(scope.row)">
              <div v-if="scope.row.isIinkman == 1" :style='{color:"#009e96"}'>是</div>
              <div v-else>否</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页start -->
      <div class="pagination">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :total="total"
          :current-page="pageIndex"
          @current-change="handleCurrentChange"
          :page-size="15"
        >
        </el-pagination>
      </div>
      <!-- 分页end -->
    </div>
  </div>
</template>

<script>
import {
  getImageUrl,
  addStockGoodsUrl,
  getMineWhiteBarListUrl,
  queryStoreEmployee,
  roleSetting,
  delEmpUrl
} from "@/api/api";
import { mapMutations, mapState } from "vuex";
export default {
  name: "whitebar",
  data() {
    return {
      tabHeight: "300px",
      formInline: {
        user: "",
        region: "",
      },
      list: null,
      selectedList: null,
      loading: false,
      total: 0,
      pageIndex: 1,
      whiteBarListShow: false,
      whiteBarList: null,
      whiteBarCount: 0,
      selectedList: null,
      currentRow: null,
    };
  },
  mounted() {
    this.getImageUrl = getImageUrl;
    this.setTableHeight();
    window.addEventListener("resize", this.setTableHeight);
    this.initData();
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    ...mapMutations(["savecurrentEditRow"]),
    initRoleName(roleName) {
      return roleName
        .split(",")
        .map((item) => {
          return roleSetting[item];
        })
        .join("-");
    },
    editstaff(row) {
      if(row.roleName==='0'){
        this.$alert('如需转移店铺管理员,请联系平台运营人员进行修改','提示')
        return 
      }
      this.savecurrentEditRow(row);
      this.$router.push({ name: "roleSetting" });
      
    },
    addWhiteBarToStore() {
      console.log(this.selectedList);
      console.log(this.currentRow);
      if (!this.selectedList.length) {
        this.$alert("请选择入库白条", "提示");
        return;
      }

      let sids = this.selectedList.map((item) => item.id).join(",");
      console.log("sids", sids);
      let data = {
        access_token: this.userInfo.access_token,
        storeId: this.userInfo.storeId,
        gid: this.currentRow.id,
        sids,
      };

      let param = new URLSearchParams();

      for (var k in data) {
        param.append(k, data[k]);
      }

      this.$axios({ method: "post", data: param, url: addStockGoodsUrl })
        .then((res) => {
          if (res.data.resultCode == 1) {
            this.whiteBarListShow = false;
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.initData();
          } else {
            this.$alert(`${res.data.resultMsg}`, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$alert("请求异常:" + error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },

    handleSelectionChange(e) {
      this.selectedList = e;
    },
    geadeFormatter(row, column) {
      switch (row.grade) {
        case 1:
          return "一级";
        case 2:
          return "二级";
        case 3:
          return "三级";
        case 4:
          return "四级";
        case 5:
          return "五级";
      }
    },
    handleCurrentChange(e) {
      console.log(e);
      this.pageIndex = e;
      setTimeout(() => {
        this.initData();
      });
    },
    checkWhiteBarAddStore(row) {
      console.log("this.userInfo", this.userInfo);
      this.loading = true;
      let breed = row.breed;
      if (breed.indexOf(",") > -1) {
        breed = breed.split(",")[2];
      }
      let data = {
        access_token: this.userInfo.access_token,
        storeId: this.userInfo.storeId,
        breed: breed,
        grade: row.grade,
        birthPlace: row.birthPlace,
        pageSize: 999,
        pageIndex: 0,
      };

      let param = new URLSearchParams();

      for (var k in data) {
        param.append(k, data[k]);
      }

      this.$axios({ method: "post", data: param, url: getMineWhiteBarListUrl })
        .then((res) => {
          this.loading = false;
          if (res.data.resultCode == 1) {
            console.log(res.data);
            if (res.data.count == 0) {
              this.$confirm(
                "暂无满足对应新的白条库存,是否添加白条入库",
                "提示",
                {
                  confirmButtonText: "添加白条",
                  cancelButtonText: "取消",
                  // type: "warning"
                }
              )
                .then(() => {
                  this.$router.push("addWhitebar");
                })
                .catch(() => {});
            } else {
              this.whiteBarCount = res.data.count;
              this.whiteBarList = res.data.data;
              this.currentRow = row;
              this.$nextTick(() => {
                this.whiteBarListShow = true;
              });
            }
          } else {
            this.$alert(`${res.data.resultMsg}`, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$alert("请求异常:" + error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    addToStore(row) {
      let { staffType, types, breed, stockCount } = row;
      if (staffType.indexOf("白条") > -1 || breed.indexOf("白条") > -1) {
        this.checkWhiteBarAddStore(row);
      } else {
        this.$prompt("请输入库数量", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then(({ value }) => {
            if (isNaN(value) || value == 0 || value >= 9999999) {
              if (value < 0 && stockCount + value < 0) {
                this.$alert("库存不足，请修改削减数量");
              } else {
                this.$alert("请输入有效数值");
              }
            } else {
              this.startAddStoreCount(row, value);
            }
          })
          .catch(() => {});
      }
    },
    startAddStoreCount(row, value) {
      console.log("this.userInfo", this.userInfo);
      let data = {
        access_token: this.userInfo.access_token,
        storeId: this.userInfo.storeId,
        gid: row.id,
        count: value,
      };

      let param = new URLSearchParams();

      for (var k in data) {
        param.append(k, data[k]);
      }

      this.$axios({ method: "post", data: param, url: addStockGoodsUrl })
        .then((res) => {
          if (res.data.resultCode == 1) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.initData();
          } else {
            this.$alert(`${res.data.resultMsg}`, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$alert("请求异常:" + error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    deletestaff(row) {
      this.$confirm("确认删除该名员工?", "提示", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        // type: "warning"
      })
        .then(() => {
          this.ensureDeletestaff(row);
        })
        .catch(() => {});
    },

    ensureDeletestaff(row) {
      this.loading = true;
      let that = this;
      console.log("this.userInfo", this.userInfo);
      let data = {
        access_token: this.userInfo.access_token,
        userId: row.userId,
      };

      let param = new URLSearchParams();

      for (var k in data) {
        param.append(k, data[k]);
      }

      this.$axios({ method: "post", data: param, url: delEmpUrl })
        .then(function (res) {
          that.loading = false;
          if (res.data.resultCode == 1) {
            that.$message({
              message: "操作成功",
              type: "success",
            });
            that.initData();
          } else {
            that.$alert(`${res.data.resultMsg}`, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch(function (error) {
          that.loading = false;
          that.$alert("请求异常:" + error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    resetPage() {
      location.reload();
    },
    handleSelectionChange(e) {
      this.selectedList = e;
    },
    setClass(row) {
      let { status, seckillstaff } = row;
      if (status == 0) {
        return "red";
      } else if (status == "-1") {
        return "purple";
      } else if (status == 1) {
        return "green";
      }
    },
    statusFormatter(row) {
      let { status, seckillstaff } = row;
      let text1 = "";
      let text2 = "";
      if (status == 0) {
        text1 = "已下架";
      } else if (status == "-1") {
        text1 = "已强制下架";
      } else if (status == 1) {
        text1 = "上架中";
      }

      if (seckillstaff) {
        text2 = "秒杀上架中";
        text1 = "";
      }
      return text1 + text2;
    },
    initData() {
      this.loading = true;
      let that = this;
      console.log("this.userInfo", this.userInfo);
      let data = {
        access_token: this.userInfo.access_token,
        storeId: this.userInfo.storeId,
        pageIndex: this.pageIndex - 1,
        pageSize: 15,
      };

      let param = new URLSearchParams();

      for (var k in data) {
        param.append(k, data[k]);
      }

      this.$axios({ method: "post", data: param, url: queryStoreEmployee })
        .then(function (res) {
          that.loading = false;
          if (res.data.resultCode == 1) {
            console.log("res.data", res.data.data);
            that.list = res.data.data;
            that.total = res.data.count || 0;
          } else {
            that.$alert(`${res.data.resultMsg}`, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          that.loading = false;
          that.$alert("请求异常:" + error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    toAddstaff() {
      this.$router.push({name:"addStaff"});
    },
    onSubmit() {
      console.log("submit!");
    },
    setTableHeight() {
      //
      setTimeout(() => {
        let headerBtn = document.getElementsByClassName("headerBtn")[0]
          .offsetHeight;
        let paginationBtn = document.getElementsByClassName("pagination")[0]
          .offsetHeight;
        let tabHeight = window.innerHeight - headerBtn - paginationBtn - 110;
        if (tabHeight < 300) {
          tabHeight = 300;
        }
        this.tabHeight = tabHeight + "px";
      }, 100);
    },
  },
};
</script>

<style scoped lang='less'>
.headerBtn {
  width: 90%;
  margin-bottom: 10px;
}
.container {
  margin: 10px;
}
.pagination {
  margin-top: 10px;
  width: 200px;
  display: flex;
  justify-content: flex-start;
}
.btnBox {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/SellCenter/StaffPage.vue